var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import * as React from "react";
import { EXPERIENCE } from "../constants";
import { selectInsuranceProduct, } from "../features/applicant/applicantSlice";
import AppBody from "../components/AppBody";
import Header from "../components/Header";
import Image from "../components/Image";
import RouteHeaderLogo from "../components/RouteHeaderLogo";
import RouteTitle from "../components/RouteTitle";
import classNames from "classnames";
import useAffiliateConfig from "../hooks/useAffiliateConfig";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
var config = {
    auto_home: {
        title: "Auto + Homeowners",
        icon: {
            path: "/assets/icons/product-auto-home-white-line.svg",
            alt: "House and car icon",
        },
        footerContent: "You're likely to get the best deal by shopping for auto and home at the same time.",
    },
    auto: {
        title: "Auto only",
        icon: { path: "/assets/icons/product-auto.svg", alt: "Car icon" },
    },
    home: {
        title: "Homeowners only",
        icon: { path: "/assets/icons/product-home.svg", alt: "House icon" },
    },
    auto_renters: {
        title: "Auto and Renters",
        icon: {
            path: "/assets/icons/product-auto-renters-white-line.svg",
            alt: "House and car icon",
        },
    },
};
function ProductOption(_a) {
    var product = _a.product, config = _a.config, className = _a.className, rest = __rest(_a, ["product", "config", "className"]);
    var experience = useAppSelector(function (state) { return state.configuration.experience; });
    var isSingleColumn = className === null || className === void 0 ? void 0 : className.includes("col-span-1");
    var title = experience === EXPERIENCE.RECONNECT
        ? config.title.replace(" only", "")
        : config.title;
    return (React.createElement("button", __assign({ id: "product-".concat(product.toString()), "data-cy": "product-".concat(product.toString()), className: classNames("block cursor-pointer overflow-hidden rounded-lg border border-gray-100 transition-all duration-200 hover:opacity-75", className) }, rest),
        React.createElement("div", { className: "flex items-center justify-between px-3 py-1 md:p-4" },
            React.createElement("div", { className: "flex items-center" },
                React.createElement(Image, { src: config.icon.path, width: isSingleColumn ? 32 : 48, height: isSingleColumn ? 32 : 48, alt: config.icon.alt, className: "mr-2" }),
                React.createElement("h2", { className: classNames("text-left font-bold leading-none", {
                        "flex-1 text-xs md:text-sm": isSingleColumn,
                    }) }, title)),
            React.createElement("svg", { width: isSingleColumn ? "18" : "24", height: isSingleColumn ? "18" : "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M5 12H19", stroke: "#222", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                React.createElement("path", { d: "M12 5L19 12L12 19", stroke: "#222", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        config.footerContent ? (React.createElement("footer", { className: "border-t border-gray-100 bg-white-300 px-4 py-2" },
            React.createElement("p", { className: "text-center text-xs text-black-300" }, config.footerContent))) : null));
}
var titleTexts = (_a = {},
    _a[EXPERIENCE.RECONNECT] = "What type of insurance are you connecting?",
    _a.DEFAULT = "What type of insurance are you shopping for today?",
    _a);
export default function InsuranceProductRoute() {
    var _a = useAppSelector(function (state) { return state.configuration; }), products = _a.products, experience = _a.experience;
    var dispatch = useAppDispatch();
    var affiliateConfig = useAffiliateConfig();
    var titleText = experience
        ? titleTexts[experience] || titleTexts.DEFAULT
        : titleTexts.DEFAULT;
    var productEntries = Object.entries(config);
    var sortedProducts = productEntries.filter(function (_a) {
        var key = _a[0];
        return products.includes(key);
    });
    function onClickInsuranceProduct(product) {
        if (product) {
            dispatch(selectInsuranceProduct({ product: product, changeRoute: true }));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement("div", { className: classNames("flex grow flex-col overflow-y-scroll px-4 md:px-6 md:pt-4 desktop:pt-2") },
                React.createElement(RouteTitle, { variant: "small", className: "mb-4 font-bold md:mb-6" }, titleText),
                React.createElement("div", { className: classNames("mb-4 grid gap-3 md:mb-6 md:gap-4", {
                        "grid-cols-2": sortedProducts.length > 3,
                    }) }, sortedProducts.map(function (_a, index) {
                    var key = _a[0], config = _a[1];
                    return config ? (React.createElement(ProductOption, { key: key, product: key, config: config, className: classNames("col-span-2", {
                            "h-14 md:col-span-1 md:h-20 desktop:col-span-1": sortedProducts.length > 3 && index > 1,
                        }), onClick: function () { return onClickInsuranceProduct(key); } })) : null;
                })),
                React.createElement("div", { className: "mt-auto pb-6 text-center text-xs font-semibold text-black-300" },
                    React.createElement("a", { className: "text-current underline", href: "https://savvy.insure/terms", target: "_blank", rel: "noreferrer" }, "Terms of Use"),
                    " ",
                    "\u00B7",
                    " ",
                    React.createElement("a", { className: "text-current underline", href: affiliateConfig.privacyPolicyURL, target: "_blank", rel: "noreferrer" }, "Privacy Policy"))))));
}
